<template>
  <el-form
    ref="editForm"
    :model="editForm"
    label-width="100px"
    :rules="editFormRules"
    @submit.prevent="onSubmit"
    style="margin: 20px; width: 60%; min-width: 600px"
  >
    <el-row>
      <el-col :span="24">
        <el-form-item label="提示：">
          <el-tag type="warning"
            >已实名认证过的姓名信息不可修改，如需修改请联系管理员！</el-tag
          >
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="姓名" prop="uRealName">
          <el-input
            :readonly="editForm.realVerifyState == 'Approved' ? 'readonly' : ''"
            v-model="editForm.uRealName"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="修改密码" prop="isUpdatePWD">
          <el-switch v-model="editForm.isUpdatePWD"></el-switch>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="editForm.isUpdatePWD">
        <el-form-item label="旧密码" prop="oldPWD">
          <el-input
            v-model="editForm.oldPWD"
            type="text"
            show-password
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-if="editForm.isUpdatePWD">
      <el-col :span="12">
        <el-form-item label="新密码" prop="uLoginPWD">
          <el-input
            v-model="editForm.uLoginPWD"
            show-password
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="确认密码" prop="uLoginPWDConfirm">
          <el-input
            v-model="editForm.uLoginPWDConfirm"
            show-password
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="editForm.sex">
            <el-radio class="radio" :label="1">男</el-radio>
            <el-radio class="radio" :label="0">女</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="生日" prop="birth">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="editForm.birth"
            @change="birthChange"
          ></el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="头像" prop="logo">
          <ImageFile
            tips="推荐尺寸1:1,大小不超过500KB"
            :value="logoImageList"
            :limiCount="1"
            :limitSize="500"
            @change="logoChange"
          ></ImageFile>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="年龄" prop="age">
          <el-input-number
            v-model="editForm.age"
            :min="0"
            :max="200"
            @change="ageChange"
          ></el-input-number>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>      
      <el-col :span="12">
        <el-form-item label="联系电话" prop="tel">
          <el-input v-model="editForm.tel"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="地址" prop="addr">
          <el-input v-model="editForm.addr"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item>
      <el-button @click="onSubmit" type="primary">更新</el-button>
      <el-button @click.native="cancel">取消</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { getUserByToken, updateMine } from "../../api/api";
import ImageFile from "../../components/ImageFile";
import moment from "moment";
export default {
  components: { ImageFile },
  data() {
    return {
      editForm: {
        uID: 0,
        name: "",
        tel: "",
        isUpdatePWD: false,
        sex: -1,
        birth: "",
        age: 0,
        addr: "",
      },
      logoImageList: [],
      token: {
        Authorization: "Bearer ",
      },
      editFormRules: {
        uRealName: [
          { required: true, message: "姓名不能为空", trigger: "blur" },
          { max: 50, message: "姓名最长不能超过50个字符", trigger: "blur" },
        ],
        tel: [
          { required: true, message: "联系电话不能为空", trigger: "blur" },
          { max: 30, message: "联系电话最长不能超过30个字符", trigger: "blur" },
        ],
        sex: [{ required: true, message: "性别不能为空", trigger: "blur" }],
        birth: [{ required: true, message: "生日不能为空", trigger: "blur" }],
        age: [{ required: true, message: "年龄不能为空", trigger: "blur" }],
        addr: [
          { required: true, message: "地址不能为空", trigger: "blur" },
          { max: 200, message: "地址最长不能超过200个字符", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    logoChange() {},
    birthChange() {
      let age = moment().diff(this.editForm.birth, "years");
      this.editForm.age = age;
    },
    ageChange() {
      let birth = moment().add(-1 * this.editForm.age, "years");
      this.editForm.birth = birth;
    },
    onSubmit() {
      if (this.editForm.isUpdatePWD) {
        this.editFormRules.oldPWD = [
          { required: true, message: "旧密码不能为空", trigger: "blur" },
        ];
        this.editFormRules.uLoginPWD = [
          { required: true, message: "新密码不能为空", trigger: "blur" },
          { max: 20, message: "新密码最长不超过20位", trigger: "blur" },
        ];
        this.editFormRules.uLoginPWDConfirm = [
          { required: true, message: "请确认密码", trigger: "blur" },
        ];
      } else {
        this.editFormRules.oldPWD = [];
        this.editFormRules.uLoginPWD = [];
        this.editFormRules.uLoginPWDConfirm = [];
      }
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {})
            .then(() => {
              let formData = new FormData();
              formData.append("model", JSON.stringify(this.editForm));
              let logos = this.logoImageList.filter((s) => s.status == "ready");
              if (logos.length > 0) {
                formData.append("logoImage", logos[0].raw);
              }
              updateMine(formData)
                .then((res) => {
                  if (res.data.isSuccess) {
                    //NProgress.done();
                    this.$message({
                      message: res.data.msg,
                      type: "success",
                    });
                    this.$refs["editForm"].resetFields();
                    this.cancel();
                  } else {
                    this.$message({
                      message: res.data.msg,
                      type: "error",
                    });
                  }
                })
                .catch((err) => {});
            })
            .catch((action) => {});
        }
      });
    },
    cancel() {
      this.$eventbus.$emit("closeTagWithPath", this.$route.path);
    },
    getUserDetail() {
      getUserByToken({ token: window.localStorage.Token }).then((res) => {
        if (res.isSuccess) {
          this.editForm = res.response;
          this.editForm.uLoginPWD = "";
          if (this.editForm.logo) {
            this.logoImageList.push(this.editForm.logo);
          }
        }
      });
    },
  },
  mounted() {
    var user = JSON.parse(window.localStorage.user);
    this.editForm.uRealName = user ? user.uRealName : "";
    this.getUserDetail();
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  text-align: center;
}
.plus-sign {
  line-height: 120px !important;
}
.avatar {
  width: 120px;
  height: 120px;
  display: block;
}

.markdown-body {
  height: 500px !important;
}
</style>